import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { obtenerContenidoSettings } from "../api";
import { motion, AnimatePresence } from "framer-motion";
import { useDynamicSplash } from "../hooks/useDynamicSplash";

const Politicas = () => {
  const [contenido, setContenido] = useState("");
  const [loadingContenido, setLoadingContenido] = useState(true);
  const showSplash = useDynamicSplash(loadingContenido);
  const navigate = useNavigate();

  // Inyectar /perfil como historial anterior
  useEffect(() => {
    window.history.replaceState({}, "", "/perfil");
    window.history.pushState({}, "", "/politicas");
  }, []);

  // Mostrar splash solo si tarda
  useEffect(() => {
    let mounted = true;

    const cargarContenido = async () => {
      setLoadingContenido(true);
      document.body.style.overflow = "hidden";
      const texto = await obtenerContenidoSettings("politicas");
      if (!mounted) return;
      setContenido(texto || "No se pudo cargar el contenido en este momento.");
      setLoadingContenido(false);
      document.body.style.overflow = "auto";
    };

    cargarContenido();

    return () => {
      mounted = false;
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <>
      {showSplash && (
        <div id="splash">
          <img src="/assets/images/loading.gif" style={{ width: 300 }} alt="Cargando..." />
        </div>
      )}
      {!showSplash && (
       <motion.div
	      initial={{ y: "100%", opacity: 0 }}
	      animate={{ y: 0, opacity: 1 }}
	      exit={{ y: "100%", opacity: 0 }}
	      transition={{ duration: 0.7, ease: "easeInOut" }}
    	>
    <div className="app-container">
      <div className="connections-container">
        <div className="back-container">
          <button className="back-btn" onClick={() => navigate("/perfil")}>
            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 512 512">
              <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="48" d="M244 400L100 256l144-144M120 256h292" />
            </svg>
          </button>
        </div>
        <h2 className="connections-title">Políticas de Privacidad</h2>
      </div>

      <div style={{ padding: 20, fontSize: 14, lineHeight: "1.7", color: "#333", whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: contenido }}>
      </div>
    </div>
    </motion.div>
    )}
    </>
  );
};

export default Politicas;
